import { Layout, Menu, Dropdown, Badge, message } from "antd";
import { setLang, selectLang } from "../store/lang/langSlice";
import { selectAuth, setAuth, logoutAsync } from "../store/auth/authSlice";
import { useDispatch, useSelector } from "react-redux";
import { DownOutlined, BellOutlined } from "@ant-design/icons";
import logoMob from "../assets/images/logo-mob-lightmode.png";
import { t } from "@lingui/macro";
import { useEffect, useState } from "react";
import ModalChangePass from "./ModalChangePass";
import { languages } from "constants/constants";
import { selectMyProfile } from "store/auth/authSlice";
import { useNavigate } from "react-router-dom";
import {
	getTotalUnreadNotificationsAsync,
	selectTotalUnreadNotifications,
} from "features/notification/redux/notification.slice";
import Notifications from "features/notification/Notifications";
import { resetListCreatingCar } from "features/cars/redux/creating-cars.slice";

const { Header: HeaderAntd } = Layout;

const Header = (props: { collapsed: boolean; isMobile: boolean }) => {
	const navigate = useNavigate();
	const { collapsed, isMobile } = props;
	const lang = useSelector(selectLang);
	const [isShowModalChangePass, setIsShowModalChangePass] = useState(false);
	const myProfile = useSelector(selectMyProfile);
	const auth = useSelector(selectAuth);
	const totalUnreadNotifications = useSelector(selectTotalUnreadNotifications);

	const { avatar, fullName } = myProfile;

	const dispatch = useDispatch();

	useEffect(() => {
		if (auth) {
			dispatch(getTotalUnreadNotificationsAsync({}));
		}
	}, []);

	const logout = () => {
		dispatch(logoutAsync());
		dispatch(setAuth(null));
		dispatch(resetListCreatingCar({}));
		setTimeout(() => {
			message.success(t`Logged out`);
		}, 100);
	};

	const handleChangeLang = (lang: string) => {
		dispatch(setLang(lang));
	};

	const StaffOpts = () => {
		const items = [
			{
				label: t`My account`,
				key: "my-account",
			},
			{
				label: t`Change password`,
				key: "change-password",
			},
			{
				label: t`Logout`,
				key: "logout",
			},
		];
		return (
			<Menu
				items={items}
				onClick={e => {
					if (e.key === "change-password") {
						setIsShowModalChangePass(true);
					} else if (e.key === "logout") {
						logout();
					} else if (e.key === "my-account") {
						navigate("/my-account");
					}
				}}
			/>
		);
	};

	const LangOptions = () => {
		const items = languages.map(el => ({
			label: (
				<div className="flex items-center">
					<img src={el.flag} alt="flag" className="w-6 mr-1" />
					<span>{el.name}</span>
				</div>
			),
			key: el.key,
		}));
		return (
			<Menu
				items={items}
				onClick={e => {
					handleChangeLang(e.key);
				}}
			/>
		);
	};

	return (
		<>
			{isShowModalChangePass ? (
				<ModalChangePass setIsShowModalChangePass={setIsShowModalChangePass} />
			) : null}
			<HeaderAntd
				className="fixed top-0 right-0 w-full p-0 z-10 shadow-[4px_4px_40px_0_rgba(0,0,0,0.05)]"
				style={{ backgroundColor: "#ffffff" }}
			>
				<div className="transition-all flex justify-end relative h-full">
					{isMobile && collapsed ? (
						<div className="flex items-center absolute top-[50%] left-[50%] translate-x-[-50%] translate-y-[-50%]">
							<img src={logoMob} alt="logo" className="h-[30px]" />
						</div>
					) : null}
					<div className="flex gap-6 items-center">
						<Dropdown
							placement="bottom"
							dropdownRender={() => <Notifications />}
							overlayClassName="fixed"
							className="mr-8"
							trigger={["click"]}
						>
							<div className="h-full flex items-center">
								<Badge
									count={totalUnreadNotifications}
									overflowCount={10}
									size="small"
									className="cursor-pointer"
								>
									<BellOutlined className="text-xl flex items-center " />
								</Badge>
							</div>
						</Dropdown>

						<Dropdown
							overlayClassName={"fixed"}
							dropdownRender={() => <StaffOpts />}
							trigger={["click"]}
						>
							<div className="cursor-pointer text-black flex items-center">
								<img
									src={avatar || "/images/default-avatar.png"}
									alt={fullName || ""}
									className="w-6 h-6 rounded-full object-cover"
								/>
								{!isMobile ? (
									<div className="ml-1">
										<span>{fullName}</span>
									</div>
								) : null}
								<DownOutlined className="pl-2" />
							</div>
						</Dropdown>
						<Dropdown
							dropdownRender={() => <LangOptions />}
							className="mr-6"
							trigger={["click"]}
							overlayClassName={"fixed"}
						>
							<div className="cursor-pointer text-black flex items-center justify-between">
								<img
									src={languages.find(el => el.key === lang)?.flag}
									alt="flag"
									className="w-6"
								/>
								{!isMobile ? (
									<span className="ml-1">
										{languages.find(el => el.key === lang)?.name}
									</span>
								) : null}
								<DownOutlined className="pl-2" />
							</div>
						</Dropdown>
					</div>
				</div>
			</HeaderAntd>
		</>
	);
};

export default Header;
